import { DatePipe } from '@angular/common';
import { ColumnDef } from '@3ddv/software-division-components/backoffice/table';
import {
  gsActionsColumn,
  gsBadgeColumn,
} from '../../shared/ui/table/gs-table.columns';
import { Transaction, TransactionStatusObj } from './models/transaction.model';

export function buildTransactionColumns(
  transactionStatus: TransactionStatusObj,
  datePipe: DatePipe,
  openDetails: (transaction: Transaction) => void
): ColumnDef<Transaction>[] {
  const statusColumn = gsBadgeColumn<Transaction>({
    id: 'status',
    header: 'Status',
    text: transaction =>
      transactionStatus.items[transaction.status.toUpperCase()].name,
    variant: transaction => {
      if (transaction.status === 'OK') {
        return 'success';
      }

      if (transaction.status === 'CA') {
        return 'danger';
      }

      return 'neutral';
    },
    dataCy: transaction => `transaction-row-${transaction.id}`,
  });

  const accountColumn: ColumnDef<Transaction> = {
    id: 'account',
    header: 'Account #',
    accessorFn: transaction => transaction.patronId ?? '',
  };

  const dateColumn: ColumnDef<Transaction> = {
    id: 'date',
    header: 'Date',
    accessorFn: transaction => datePipe.transform(transaction.createdAt) ?? '',
  };

  const eventColumn: ColumnDef<Transaction> = {
    id: 'event',
    header: 'Event',
    accessorFn: transaction =>
      `${transaction.event?.description ?? 'No description'} / ${transaction.event?.code ?? 'No code'}`,
  };

  const balanceColumn: ColumnDef<Transaction> = {
    id: 'balance',
    header: 'Balance',
    accessorFn: transaction => `$ ${transaction.tdcTransaction?.balance ?? ''}`,
  };

  const detailsColumn = gsActionsColumn<Transaction>({
    actions: [
      {
        id: 'details',
        label: 'Details',
        dataCy: transaction => `transaction-details-button-${transaction.id}`,
        indicator: transaction => transaction.hasUnreadErrors,
      },
    ],
    onSelect: (_actionId, transaction) => openDetails(transaction),
  });

  return [
    statusColumn,
    accountColumn,
    dateColumn,
    eventColumn,
    balanceColumn,
    detailsColumn,
  ];
}
